import { useConfig } from "@/api/hooks/useConfig";
import { NavHeaderInterface } from "@/components/Sidebar/Sidebar.interface";
import { getNavigationInterface } from "@/components/Sidebar/components/NavSection";
import { useTrans } from "@/translations";

import React from "react";

export const NavHeader: React.FC<NavHeaderInterface> = ({ type }) => {
  const { t } = useTrans();
  const { config, isRealEstate } = useConfig();

  if (!config) return null;

  const navigation = getNavigationInterface({
    isRealEstate,
    useExternalCRM: !!config.useExternalCRM,
  });
  const Icon = navigation[type].icon;

  return (
    <h6 className="font-dm-sans flex items-center pl-5 text-base font-semibold uppercase">
      <span className="block pr-2.5">
        <Icon />
      </span>
      {t(`sidebarLabels:${type}`)}
    </h6>
  );
};
